function PostcodeLookupCtrl($scope, $rootScope, $q, ValidatorService, LoadingService, $attrs) {
    'ngInject';


    /*
    TODO: This controller is not used anywhere.
    The angular.extend method below, will not work as CompanyListBase
    does not exist here. 'this', is also not used anywhere else.
    Consider deleting.
    */
    angular.extend(this, new CompanyListBase($scope, $rootScope, $q, $attrs));

    const loader = LoadingService.$loader($scope);

    /***
     * @ngdoc method
     * @name searchPostcode
     * @methodOf BB:bbCompanies
     * @description
     * Search the postcode
     *
     * @param {object} form The form where postcode has been searched
     * @param {object} prms The parameters of postcode searching
     */
    $scope.searchPostcode = (form, prms) => {

        loader.notLoaded();

        const promise = ValidatorService.validatePostcode(form, prms);
        if (promise) {
            return promise.then(() => {
                    $scope.bb.postcode = ValidatorService.getGeocodeResult().address_components[0].short_name;
                    $scope.postcode = $scope.bb.postcode;
                    const loc = ValidatorService.getGeocodeResult().geometry.location;
                    return $scope.selectItem($scope.getNearestCompany({center: loc}));
                }
                , err => loader.setLoaded());
        } else {
            return loader.setLoaded();
        }
    };

    /***
     * @ngdoc method
     * @name getNearestCompany
     * @methodOf BB:bbCompanies
     * @description
     * Get nearest company in according of centre parameter
     *
     * @param {string} centre Map centre
     */
    $scope.getNearestCompany = ({centre}) => {

        const distances = [];

        for (const company of Array.from($scope.items)) {

            if (company.address.lat && company.address.long && company.live) {

                const map_centre = {
                    lat: center.lat(),
                    long: centre.lng()
                };

                const company_position = {
                    lat: company.address.lat,
                    long: company.address.long
                };

                company.distance = GeolocationService.haversine(map_centre, company_position);

                distances.push(company);
            }
        }

        distances.sort((a, b) => {
                return a.distance - b.distance;
            }
        );

        return distances[0];
    };
}

function postcodeLookupDirective() {
    'ngInject';

    return {
        restrict: 'AE',
        replace: true,
        scope: true,
        controller: PostcodeLookupCtrl
    };
}

angular
    .module('BB')
    .directive('bbPostcodeLookup', postcodeLookupDirective);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/postcode-lookup/postcode_lookup.directive.js